<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.userWeb')">
          <form>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userWebParams.login"
                  value="userWebParams.login"
                  :placeholder="$t('forms.inputs.login')"
                >
                </va-input>
              </div>
              
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userWebParams.password"
                  value="userWebParams.password"
                  type="password"
                  :placeholder="$t('forms.inputs.password')"
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userWebParams.re_password"
                  value="userWebParams.re_password"
                  type="password"
                  :placeholder="$t('forms.inputs.repeatPassword')"
                >
                </va-input>
              </div>

            </div> <!-- end row -->

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userWebParams.name"
                  value="userWebParams.name"
                  :placeholder="$t('forms.inputs.name')"
                >
                </va-input>
              </div>
              
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userWebParams.cpf"
                  value="userWebParams.cpf"
                  :placeholder="$t('forms.inputs.cpf')"
                >
                </va-input>
              </div>
            
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.selectRole')"
                  v-model="userWebParams.role_id"
                  textBy="name"
                  :options="rolesOptions"
                />
              </div>
            </div> <!-- fim row -->

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.selectShift')"
                  v-model="userWebParams.shift_id"
                  textBy="name"
                  :options="shiftsOptions"
                />
              </div>
              
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="userWebParams.phone"
                  value="userWebParams.phone"
                  v-mask="maskTel"
                  :placeholder="$t('forms.inputs.celPhone')"
                >
                </va-input>
              </div>
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.selectGender')"
                  v-model="userWebParams.gender"
                  textBy="description"
                  :options="gendesOptions"
                />
              </div>
            </div>

            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  v-if="userWebParams.userWebId == ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="create(userWebParams)"
                >
                  {{ $t('menu.save') }}
                </va-button>
                <va-button
                  v-else
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="update(userWebParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>
              </div>
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  to="/admin/tables/users_operacional"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import UserWebAPI from '@/services/UserWebAPI'
import RoleAPI from '@/services/RoleAPI'
import ShiftAPI from '@/services/ShiftAPI'

export default {
  name: 'form-user-web',
  components: {},
  data () {
    return {
      userWebParams: {
        userWebId: '',
        login: '',
        password: '',
        name: '',
        gender: '',
        phone: '',
        cpf: '',
        role_id: '',
        shift_id: '',
      },
      maskTel: '(##)#-####-####',
      genderTipe: '',
      rolesOptions: [],
      shiftsOptions: [],
      gendesOptions: [
        {
          id: 1,
          description: 'Masculino',
        },
        {
          id: 2,
          description: 'Feminino',
        },
      ]
    }
  },
  mounted () {
    RoleAPI.getAllRoles().then(response => {
      let rolesFiltered = response.data.filter(function (roles) {
        return roles.name == "Sistema" || roles.name == "Operacional";
      });
      
      this.rolesOptions = rolesFiltered;
    })

    ShiftAPI.getAllShifts().then(response => {
      this.shiftsOptions = response.data
    })

    if (this.$route.params.id != undefined) {
      UserWebAPI.getUserWebById(this.$route.params.id).then(response => {
        this.userWebParams = response.data

        let gender = this.userWebParams.gender

        if (gender == "M") {
          this.userWebParams.gender = "Masculino"
        } else if (gender == "F") {
          this.userWebParams.gender = "Feminino"
        } else {
          this.userWebParams.gender = ""
        }

        ShiftAPI.getShiftById(response.data.shift_id).then(res_shift => {
          this.userWebParams.shift_id = res_shift.data
        })
        
        RoleAPI.getRoleById(response.data.role_id).then(res_role => {
          this.userWebParams.role_id = res_role.data
        })
        
      })
    }
  },
  methods: {
    create (userWebParams) {
      if (userWebParams.password === userWebParams.re_password) {
        UserWebAPI.createUserWeb(userWebParams).then(response => {
          this.userWeb = response.data;

            this.showToast(response.data.message, {
              icon: 'fa-thumbs-o-up',
              position: 'top-right',
              duration: 5000,
            }),
            
          this.$router.push('/admin/tables/users_operacional')

        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        });
      } else {
        this.showToast(`A senhas não são iguais.`, {
          icon: 'thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      }
    },
    update (userWebParams) {
      if (userWebParams.password === userWebParams.re_password) {
        UserWebAPI.updateUserWeb(userWebParams).then(response => {
          self.data = response.data;

            this.showToast(response.data.message, {
              icon: 'fa-thumbs-o-up',
              position: 'top-right',
              duration: 5000,
            }),
            
          this.$router.push('/admin/tables/users_operacional')
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        });
      } else {
        this.showToast(`A senhas não são iguais.`, {
          icon: 'thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      }
    }
  },
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
